var _path, _path2, _path3, _path4, _path5, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 235 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 51.4999C-3.99999 -1.00046 2.66669 122.166 25 191H215.5C230 160 232.473 94.5 211 46.9999C178 -26 116.315 -5.43385 87 51.4999Z",
    fill: "#D3F8A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 113.5C40.1 123.9 48 171.833 56 194.5H199C214.2 105.7 171 98.8334 147.5 106.5C111.9 56.1 82.6667 90.1667 72.5 113.5Z",
    fill: "#96C55C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 195.632C0 190.109 4.47715 185.632 10 185.632H225C230.523 185.632 235 190.109 235 195.632V199.632H0V195.632Z",
    fill: "#96C55C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4505 189.7C22.3404 177.334 25.8854 148.176 40.9464 130.467C34.4579 147.447 26.9225 187.627 37.4886 195.975L41.0143 197.446C39.6641 197.276 38.4944 196.769 37.4886 195.975L22.4505 189.7Z",
    fill: "#96C55C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7733 111.655C18.1303 108.792 14.0865 112.881 20.5152 121.979C14.5013 126.681 17.37 131.077 20.5152 134.348C13.4287 145.461 27.7733 149.931 31.9208 144.263C40.838 156.836 47.3012 148.528 48.5109 145.461C70.0056 151.891 63.6148 128.247 61.2645 124.739C69.2485 109.917 58.1539 102.761 48.5109 106.646C40.4232 95.5036 25.3885 99.1835 27.7733 111.655Z",
    fill: "url(#paint0_linear_128_7)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41,
    cy: 126.5,
    rx: 8,
    ry: 7.5,
    fill: "#FF8A00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_7",
    x1: 41.4352,
    y1: 100,
    x2: 41.4352,
    y2: 150.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.939fffc79b29f60167a2f49a691ac010.svg";
export { ForwardRef as ReactComponent };